import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {BehaviorSubject, Subject} from 'rxjs';
import {map} from 'rxjs/operators';
import {peopleUrl} from '../api-url';

@Injectable({
  providedIn: 'root'
})
export class AdminUsersService {
  users: any[] = [];
  usersUpdated = new BehaviorSubject<any[]>([]);
  constructor(private http: HttpClient, private route: Router) { }

  getUsers() {
    this.http.get<any>(peopleUrl).pipe(
      map(data => data.filter(el => el.accessLevel === 'Regular')
      )
    )
      .subscribe(
        regularUsers => {
          this.users = regularUsers;
          this.usersUpdated.next([...this.users]);
        }
      );
  }
  getUsersListener() {
    return this.usersUpdated.asObservable();
  }
  addUser(user) {
    this.http.post<any>(peopleUrl, user)
      .subscribe(responseData => {
        this.users.push(user);
        this.usersUpdated.next([...this.users]);
        this.route.navigate(['/admin/people']);
      });
  }
  removeUser(personId) {
    this.http.delete(`${peopleUrl}/personId`)
      .subscribe(() => {
        const updatedUsers = this.users.filter(user => user.personId !== personId);
        this.users = updatedUsers;
        this.usersUpdated.next([...this.users]);
      });
  }
  updateUser(personId, user) {
    this.http.put(`${peopleUrl}/` + personId, user).subscribe(response => {
        this.route.navigate(['/app/admin/purposes']);
      // const updatedUsers = [...this.users];
      // const oldIndex = updatedUsers.findIndex(p => p.personId === personId);
      // updatedUsers[oldIndex] = user;
      // this.users = updatedUsers;
      // this.usersUpdated.next([...this.users]);
    });
  }
}
